
export function requireElement<T extends HTMLElement = HTMLElement>(element: HTMLElement, selector: string): T {
    const el = element.querySelector<T>(selector);
    if (!el) {
        throw new Error(`Missing required element: ${selector}`);
    }

    return el;
}

export function delegateListener<K extends keyof HTMLElementEventMap>(
    parent: HTMLElement,
    type: K,
    selector: string,
    handler: (event: HTMLElementEventMap[K], target: HTMLElement) => void,
) {
    parent.addEventListener(type, (event) => {
        const target = event.target as HTMLElement | null;
        if(!target) return;

        const matched = target.closest<HTMLElement>(selector);
        if(!matched || !parent.contains(matched)) return;

        handler(event, matched);
    });
}

export function splitKeyValue(string: string) {
    return string.split('&').reduce((acc, item) => {
        const [key, value] = item.split('=');
        acc[key] = value;
        return acc;
    }, {} as Record<string, string>)
}

// let libraryPromise: Record<string, Promise<void>> = {};
// export function loadHubspotLibrary(script: string): Promise<void> {
//     if (libraryPromise && libraryPromise[script]) {
//         return libraryPromise[script];
//     }
//
//     libraryPromise[script] = new Promise((resolve, reject) => {
//         // Already loaded?
//         if (window.hbspt) {
//             resolve();
//             return;
//         }
//
//         const script = document.createElement('script');
//         script.src = 'https://js.hsforms.net/forms/embed/v2.js';
//         script.async = true;
//         script.onload = () => resolve();
//         script.onerror = () => reject(new Error('Failed to load hubspot forms'));
//
//         document.head.appendChild(script);
//     });
//
//     return libraryPromise[script];
// }
